import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderFour from "../common/header/HeaderFour";
import SEO from "../common/SEO";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import PricingOne from "../component/pricing/PricingOne";
import Cover from "../component/pricing/Cover";
import FaqOne from "../component/faq/FaqOne";
import ChatbotTwo from "./ChatbotTwo";

const PricingTable = () => {
  return (
    <>
      <SEO />
      <main className="main-wrapper">
        <HeaderFour />
        {/* <BreadCrumbOne title="Start Clifing!" page="Membership" /> */}
        <div className="section section-padding mt-5">
          <div className="container mt-5">
            <div className="section-heading mb-0">
              <h2 className="title">Choose the Right Career Plan for You</h2>
              <div className="subtitle">
                {" "}
                Your journey to the dream job, simplified and structured. Choose
              </div>
              <p style={{ fontSize: "20px" }}></p>
            </div>
          </div>
          <ul className="shape-group-3 list-unstyled">
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-4.png"}
                alt="shape"
              />
            </li>
          </ul>
        </div>
        <PricingOne />
        <Cover />
        <FaqOne />
        <CtaLayoutOne />
        <FooterOne parentClass="" />
        <ChatbotTwo />
      </main>

      <style jsx>{`
        .shape-group-3 .shape {
          z-index: -1; /* Ensures the shape elements appear behind other content */
        }
        @media only screen and (max-width: 991px) {
          .section-heading .title {
            font-size: 45px;
          }
        }
      `}</style>
    </>
  );
};

export default PricingTable;
